module.exports = __webpack_public_path__ + "assets/contact-rings.c487eade.svg";